<template>
  <div class="space-y-6">
    <div>
      <h2 class="text-base font-semibold text-gray-900">Company Profile</h2>
      <p class="text-sm text-gray-500 mt-0.5">Business details and contact information</p>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="bg-white rounded-xl border border-gray-200 py-16 text-center">
      <i class="fa-solid fa-spinner fa-spin text-gray-400 text-xl mb-3"></i>
      <p class="text-sm text-gray-400">Loading company profile...</p>
    </div>

    <template v-else>
      <div class="bg-white rounded-xl border border-gray-200 p-6">
        <div class="space-y-4 max-w-lg">
          <div>
            <label class="text-xs font-medium text-gray-500 block text-left mb-1">Company Name</label>
            <input v-model="form.companyName" type="text" placeholder="Your company name"
              class="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-700 outline-none focus:border-indigo-400 transition-colors" />
          </div>
          <div>
            <label class="text-xs font-medium text-gray-500 block text-left mb-1">Primary Phone</label>
            <input v-model="form.primaryPhone" type="text" placeholder="+61..."
              class="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-700 outline-none focus:border-indigo-400 transition-colors" />
          </div>
          <div>
            <label class="text-xs font-medium text-gray-500 block text-left mb-1">Forward-To Phone</label>
            <input v-model="form.forwardToPhone" type="text" placeholder="+61..."
              class="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-700 outline-none focus:border-indigo-400 transition-colors" />
            <p class="text-xs text-gray-400 mt-1 text-left">Unmatched inbound SMS will be forwarded to this number</p>
          </div>
          <div>
            <label class="text-xs font-medium text-gray-500 block text-left mb-1">Twilio From Number</label>
            <input v-model="form.twilioFromNumber" type="text"
              class="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-700 outline-none focus:border-indigo-400 transition-colors" />
            <p class="text-xs text-gray-400 mt-1 text-left">The Twilio phone number used to send outbound SMS</p>
          </div>
          <div>
            <label class="text-xs font-medium text-gray-500 block text-left mb-1">Email</label>
            <input v-model="form.email" type="email" placeholder="office@company.com"
              class="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-700 outline-none focus:border-indigo-400 transition-colors" />
          </div>
        </div>
      </div>

      <!-- Save -->
      <div class="flex justify-end">
        <button @click="save()" :disabled="saving"
          class="inline-flex items-center px-5 rounded-lg text-sm font-medium bg-primary text-white hover:opacity-90 transition-colors disabled:opacity-50"
          style="height:40px">
          <i v-if="saving" class="fa-solid fa-spinner fa-spin mr-1.5"></i>
          {{ saving ? 'Saving...' : 'Save Changes' }}
        </button>
      </div>

      <div v-if="saved" class="flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-lg">
        <i class="fa-solid fa-circle-check text-green-600"></i>
        <span class="text-sm text-green-700 font-medium">Company profile saved</span>
      </div>
    </template>
  </div>
</template>

<script>
import { auth } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";

const API_BASE = "https://us-central1-ktc-app-33f33.cloudfunctions.net/widgets/api/v1/settings";

export default {
  data() {
    return {
      loading: false,
      saving: false,
      saved: false,
      form: {
        companyName: '',
        primaryPhone: '',
        forwardToPhone: '',
        twilioFromNumber: '+61483915881',
        email: '',
      },
    };
  },
  methods: {
    getCurrentUser() {
      return new Promise((resolve, reject) => {
        if (auth.currentUser) return resolve(auth.currentUser);
        const unsub = onAuthStateChanged(auth, (user) => {
          unsub();
          user ? resolve(user) : reject(new Error('Not authenticated'));
        });
      });
    },
    async getHeaders() {
      const user = await this.getCurrentUser();
      const token = await user.getIdToken();
      return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
    },
    async fetchData() {
      this.loading = true;
      try {
        const headers = await this.getHeaders();
        const res = await fetch(`${API_BASE}/company`, { headers });
        const json = await res.json();
        const data = json.data || {};
        this.form = {
          companyName: data.companyName || '',
          primaryPhone: data.primaryPhone || '',
          forwardToPhone: data.forwardToPhone || '',
          twilioFromNumber: data.twilioFromNumber || '+61483915881',
          email: data.email || '',
        };
      } catch (e) {
        console.error('Failed to load company profile:', e);
      }
      this.loading = false;
    },
    async save() {
      this.saving = true;
      this.saved = false;
      try {
        const headers = await this.getHeaders();
        const body = { ...this.form };
        await fetch(`${API_BASE}/company`, {
          method: 'PUT',
          headers,
          body: JSON.stringify(body),
        });
        this.saved = true;
        setTimeout(() => { this.saved = false; }, 3000);
      } catch (e) {
        console.error('Failed to save company profile:', e);
      }
      this.saving = false;
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
